<button
  type="button"
  class="sidebar-toggle"
  (click)="toggleMobileMenu()"
  [attr.aria-expanded]="isMobileMenuOpen"
  aria-controls="admin-sidebar"
  aria-label="Alternar menu">
  <mat-icon>{{ isMobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
</button>

<div class="sidebar-backdrop" *ngIf="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

<div id="admin-sidebar" class="sidebar" [class.is-open]="isMobileMenuOpen" (mouseenter)="menuOpen()" (mouseleave)="menuClose()">
  <ul class="sidebar-menu">
    <ng-container *ngIf="menuUser === '1' || menuUser === '2' || menuUser === '3' ">
      <li class="sidebar-item" (click)="itemSelected('clientes')" [ngClass]="{'active': menuSelected === 'clientes'}">
        <a>
          <mat-icon class="icon">groups</mat-icon>
          <span class="text">Clientes</span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="menuUser === '1' || menuUser === '2' || menuUser === '3' ">
      <li class="sidebar-item" (click)="itemSelected('licencas')" [ngClass]="{'active': menuSelected === 'licencas'}">
        <a>
          <mat-icon class="icon">article</mat-icon>
          <span class="text">Licenças</span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="menuUser === '1' || menuUser === '2' || menuUser === '3' ">
      <li class="sidebar-item" (click)="itemSelected('webhooks')"
        [ngClass]="{'active': menuSelected === 'webhooks'}">
        <a>
          <mat-icon class="icon">webhook</mat-icon>
          <span class="text">WebHooks</span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="menuUser >= '1'">
      <li class="sidebar-item" (click)="itemSelected('configuracoes')"
        [ngClass]="{'active': menuSelected === 'configuracoes'}">
        <a>
          <mat-icon class="icon">settings</mat-icon>
          <span class="text">Configuração</span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="menuUser === '3'">
      <li class="sidebar-item" (click)="itemSelected('relatorios')"
        [ngClass]="{'active': menuSelected === 'relatorios'}">
        <a>
          <mat-icon class="icon">bar_chart</mat-icon>
          <span class="text">Relatórios</span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="menuUser === '3'">
      <li class="sidebar-item" (click)="itemSelected('revendedores')"
        [ngClass]="{'active': menuSelected === 'revendedores'}">
        <a>
          <mat-icon class="icon">handshake</mat-icon>
          <span class="text">Revendedor</span>
        </a>
      </li>
    </ng-container>
  </ul>

  <div class="logout-section">
    <a class="logout-btn" (click)="logout()">
      <mat-icon class="icon">logout</mat-icon>
      <span class="text">Sair</span>
    </a>
  </div>
</div>
